import * as React from 'react';

import { OptionalAnchor } from '../OptionalAnchor';

import * as styles from './styles.css';

export interface IAboutBuildingProps {
  buildingInfo?: string;
  link?: string;
  name?: string;
  linkTarget?: string;
  onLinkClick(): void;
}

export class AboutBuilding extends React.Component<IAboutBuildingProps> {
  public render() {
    const { name, buildingInfo } = this.props;

    return (
      <div className={styles['container']}>
        {name && (
          <OptionalAnchor
            href={this.props.link}
            rel="noopener"
            target={this.props.linkTarget}
            className={styles['name']}
            onAnchorClick={this.handleLinkClick}
          >
            {name}
          </OptionalAnchor>
        )}
        {buildingInfo && <div className={styles['building-info']}>{buildingInfo}</div>}
      </div>
    );
  }

  private handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();

    this.props.onLinkClick();
  };
}
